var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.23,30.89H9.82c-.3,0-.71-.4-.71-.7V9.89c0-.45.39-.75.75-.78.31-.03.8.31.8.74v19.5s19.49,0,19.49,0c.44,0,.69.42.73.67.04.29-.17.87-.65.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.59,24.01c-.39.36-.87.37-1.18.04-.35-.38-.23-.85.15-1.2l4.74-4.3c.49-.24.78.02,1.09.36l3.2,3.5,7.94-7.95c.27-.27.48-.3.85-.2.24.07.48.32.5.54.03.31-.09.55-.32.78l-8.49,8.5c-.33.24-.78.28-1.06-.03l-3.39-3.74-4.04,3.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.a0e1111268469b2ab332467abebc9a73.svg";
export { ForwardRef as ReactComponent };